var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationDrawer',{attrs:{"items":_vm.items,"baseRoute":"/rules/sotg"}})}
var staticRenderFns = []

export { render, staticRenderFns }